import React from 'react';
import { createPortal } from 'react-dom';
import BaseOverlay from '../layout/BaseOverlay.jsx';
import ReactMarkdown from 'react-markdown';

const OrganizationsAIInfoOverlay = ({
    showOrgInfoOverlay,
    setShowOrgInfoOverlay,
    selectedOrganization,
    setSelectedOrganization
}) => {
    const closeOverlay = () => {
        setShowOrgInfoOverlay(false);
        setSelectedOrganization(null);
    };

    const overlayContent = (
        <BaseOverlay show={showOrgInfoOverlay} className='overflow-auto h-[100dvh] z-[1002] rounded-none'>
            <div className='min-h-96 max-w-3xl w-full mx-auto px-4'>
                <div className='flex justify-end py-4'>
                    <div className='text-theme1-primary font-bold' onClick={closeOverlay}>
                        Close
                    </div>
                </div>
                <div className='text-center text-theme1-title2 font-bold text-[22px] mb-3'>
                    {selectedOrganization.name}
                </div>

                <div className='flex justify-between items-start mb-4 mt-4'>
                    <span className='text-theme1-dark text-[16px] whitespace-pre-wrap w-[90%] sm:w-[95%]'>
                        <ReactMarkdown>{selectedOrganization.openai_info}</ReactMarkdown>
                    </span>
                </div>
            </div>
        </BaseOverlay>
    );

    return <>{createPortal(overlayContent, document.body)}</>;
};

export default OrganizationsAIInfoOverlay;
